module.exports = __webpack_public_path__ + "static/media/b99-post-top.7afdf012.png";